/**
 * Created by or_p on 8/31/2016.
 */
import _ from 'lodash';
import { createSelector } from 'reselect';
import update from 'react-addons-update';
import { elementTypes } from 'crazyEditor/components/Elements/index';

const getTemplateTagSpecifics = (state) => state.templateTagSet.templateTagSpecifics;
const getTemplateTagSet = (state) => state.templateTagSet;

export const getNormalizedTemplateTagSpecifics = createSelector(
  [getTemplateTagSpecifics, getTemplateTagSet],
  (templateTagSpecifics, templateTagSet) => {
    const tagsUpdates = {};
    const normalizedTemplateTagSpecifics = _.keyBy(templateTagSpecifics, 'templateTag.name');
    _.forEach(normalizedTemplateTagSpecifics, (tag, key) => {
      const tagUpdates = {};
      if (_.isEmpty(tag.displayName)) {
        tagUpdates.displayName = tag.templateTag.displayName;
      }
      if (_.isEmpty(tag.placeholder)) {
        tagUpdates.placeholder = tag.templateTag.placeholder;
      }
      tagUpdates.name = tag.templateTag.name;
      tagUpdates.order = tag.templateTag.order;
      tagUpdates.preset = tag.templateTag.preset;
      tagUpdates.richText = tag.templateTag.richText;
      tagUpdates.tooltip = tag.templateTag.tooltip;
      tagUpdates.icon = tag.templateTag.icon;
      tagUpdates.draftPlaceholder = tag.templateTag.draftPlaceholder;
      tagsUpdates[key] = {$merge: tagUpdates};
    });
    tagsUpdates[elementTypes.GalleryElement] = {
      $set: {
        maxImages: templateTagSet.galleryMaxImages,
        imageCountTag: templateTagSet.galleryImageCountTag,
        imageTag: templateTagSet.galleryImageTag,
        firstImageTag: templateTagSet.galleryFirstImageTag,
        startIndex: templateTagSet.galleryStartIndex,
      },
    };
    if (!_.isEmpty(templateTagSpecifics)) {
      return update(normalizedTemplateTagSpecifics, tagsUpdates);
    }
    return null;
  }
);
